import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { MutationOption, queryClient } from "libs/react-query";
import * as KeyFactory from "./exchange-query-key-factory";
import * as VariantKeyFactory from "../../mitigation/variant/variant-query-key-factory";

interface ISetExchangeProducer {
  exchangeId: string;
  producerId: string;
}

/**
 * Sets the Producer of a exchange
 *
 * @param {string} exchangeId - uuid of the exchange
 * @param {string} producerId - uuid of producer for exchange
 */
export const setExchangeProducer = ({ exchangeId, producerId }: ISetExchangeProducer) => {
  return Brm.exchangeApi.setExchangeProducer(exchangeId, { body: producerId });
};

interface IUseSetExchangeProducer {
  options?: MutationOption<typeof setExchangeProducer>;
}

/**
 * Custom hook to change the Producer of an existing exchange
 *
 * @param {object} options - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetExchangeProducer = ({ options }: IUseSetExchangeProducer = {}) => {
  return ReactQuery.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(KeyFactory.exchangeKeys.all);
      queryClient.invalidateQueries(VariantKeyFactory.variantsKeys.all);
    },
    ...options,
    mutationFn: setExchangeProducer,
  });
};
